import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './guards/auth-guard.service';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home'
    },
    {
        path: 'account',
        loadChildren: () =>
            import('./account/account.module').then((m) => m.AccountModule),
    },
    {
        path: 'home',
        loadChildren: () =>
            import('./home/home.module').then((m) => m.HomeModule),

    },
    {
        path: 'shopping-cart',
        loadChildren: () =>
            import('./shopping-cart/shopping-cart.module').then((m) => m.ShoppingCartModule),

    },
    {
        path: 'shopping-cart-review',
        loadChildren: () =>
            import('./shopping-cart-review/shopping-cart-review.module').then((m) => m.ShoppingCartReviewModule)
    },
    {
        path: 'order-history',
        loadChildren: () =>
            import('./order-history/order-history.module').then((m) => m.OrderHistoryModule)
    },
    {
        path: 'wishlist',
        loadChildren: () =>
            import('./wishlist/wishlist.module').then((m) => m.WishlistModule)
    },
    {
        path: 'search',
        loadChildren: () =>
            import('./search/search.module').then((m) => m.SearchModule)
    },
    {
        path: 'search-category',
        loadChildren: () =>
            import('./search-category/search-category.module').then((m) => m.SearchCategoryModule)
    },
    {
        path: 'product-details/:id',
        loadChildren: () =>
            import('./product-details/product-details.module').then((m) => m.ProductDetailsModule)
    },
    {
        path: 'credit-conversion',
        loadChildren: () =>
            import('./credit-letter/credit-letter.module').then((m) => m.CreditLetterModule),
        canActivate: [AuthGuardService]
    },
    {
        path: 'company',
        loadChildren: () =>
            import('./company/company.module').then((m) => m.CompanyModule),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
